// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-text-footer_container__FzfwS","headText":"roomstay-blog-text-footer_headText__KWQmQ","subText":"roomstay-blog-text-footer_subText__d50ed"};